import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

@Component({
  selector: 'app-resendverificationemail',
  templateUrl: './resendverificationemail.component.html',
  styleUrls: ['./resendverificationemail.component.css']
})
export class ResendverificationemailComponent implements OnInit {
  isLoading: boolean;
  confirmemail: boolean = false;
  constructor(private userservice: UseraccessserviceService, private toastr: ToastrService) { }

  ngOnInit(): void {
  }
  async OnSubmit(email: string) {
    this.isLoading = true
    var data: any = await this.userservice.resendconfirmationemail(email).toPromise();
    this.isLoading = false;
    this.toastr.success(data.msg);
    this.confirmemail = true;
  }
}
